import { render, staticRenderFns } from "./SalesReport.vue?vue&type=template&id=3b35aac8&scoped=true"
import script from "./SalesReport.vue?vue&type=script&lang=js"
export * from "./SalesReport.vue?vue&type=script&lang=js"
import style0 from "./SalesReport.vue?vue&type=style&index=0&id=3b35aac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b35aac8",
  null
  
)

export default component.exports